import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Select } from "antd";

const { Option } = Select;

const MappingForm = ({ onSubmit, onCancel, initialValues }) => {
  const [form] = Form.useForm();
  const [columnType, setColumnType] = useState(
    initialValues?.columnType || "string"
  ); // Initialize with null or initial value

  const onFinish = (values) => {
    onSubmit(values); // Pass form values to the parent component
    form.resetFields();
  };

  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 2) {
      form.setFieldsValue(initialValues);
      setColumnType(initialValues.columnType || "string"); // Set columnType based on initialValues
    } else {
      form.resetFields();
      setColumnType(null); // Reset columnType to null if initialValues is empty
    }
  }, [form, initialValues]);

  return (
    <Form
      form={form}
      name="mapping"
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues} // Populate form if in edit mode
    >
      <Form.Item
        label="Key"
        name="key"
        rules={[{ required: true, message: "Please input the Key!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Title"
        name="title"
        rules={[{ required: true, message: "Please input the Title!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Order"
        name="order"
        rules={[{ required: true, message: "Please input the Order!" }]}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item label="Value" name="value">
        <Input />
      </Form.Item>

      <Form.Item label="Column Type" name="columnType">
        <Select
          onChange={(value) => {
            setColumnType(value);
            form.setFieldsValue({
              format: value === "time" ? "HH:mm" : undefined,
            });
          }}
          placeholder="Select Column Type"
        >
          <Option value="">Select Column Type</Option>{" "}
          <Option value="string">String</Option>
          <Option value="sourceId">Source File</Option>
          <Option value="number">Number</Option>
          <Option value="date">Date</Option>
          <Option value="time">Time</Option>
          <Option value="datetime">DateTime</Option>
        </Select>
      </Form.Item>

      {columnType === "date" && (

        <Form.Item
          label="Date Format"
          name="format"
          rules={[{ required: true, message: "Please input the Format!" }]} // Make format required for date
        >
          <Input placeholder="e.g., YYYY-MM-DD" />
        </Form.Item>
      )}
      {columnType === "datetime" && (

        <Form.Item
          label="Date Format"
          name="format"
          rules={[{ required: true, message: "Please input the Format!" }]} // Make format required for date
        >
          <Input placeholder="e.g., YYYY-MM-DD" />
        </Form.Item>
      )}

      {columnType === "time" && (
        <Form.Item label="Time Format" name="format">
          <Input placeholder="e.g., HH:mm" />
        </Form.Item>
      )}
      {columnType === "number" && (
        <Form.Item name="includeSequentialNumber" valuePropName="checked">
          <Checkbox>Include Sequential Number</Checkbox>
        </Form.Item>
      )}

      <Form.Item name="hasHardcodedValue" valuePropName="checked">
        <Checkbox>Has Hardcoded Value</Checkbox>
      </Form.Item>

      <Button type="primary" htmlType="submit">
        Submit
      </Button>
      <Button style={{ marginLeft: "10px" }} onClick={onCancel}>
        Cancel
      </Button>
    </Form>
  );
};

export default MappingForm;
